import React from 'react';
import { View, StyleSheet } from "react-native";
import { Calendar, DateData } from 'react-native-calendars';
import dayjs from 'dayjs';
import { useRouter } from 'expo-router';
import { usePersistBoundStore } from '@/services/zustand/Store';

const INITIAL_DATE = dayjs().format('YYYY-MM-DD');

export default function DatePicker() {
    const router = useRouter();
    const updateSelectedDate = usePersistBoundStore((state) => state.updateSelectedDate);

    const handleLinkPress = (date: DateData) => {
        //console.log("Datepicker.tsx - handleLinkPress")
        if (date?.dateString) {
            const formattedDate = dayjs(date.dateString).format('YYYYMMDD').toString();
            updateSelectedDate(formattedDate);
            router.back();
        }
    };
    return (
        <View>
            <Calendar
                enableSwipeMonths
                current={INITIAL_DATE}
                style={styles.calendar}
                onDayPress={handleLinkPress}
                onDayHover={() => console.log('onDayHover')}
            />
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#F5FCFF',
    },
    dayContainer: {
        justifyContent: 'center',
        alignItems: 'center',
    },
    customText: {
        fontSize: 12,
        color: 'gray',
    },
    text: {
        textAlign: 'center',
        padding: 10,
        backgroundColor: 'lightgrey',
        fontSize: 16
    },
    calendar: {
        marginBottom: 10
    },
});
